<template>
    <div class="columns-segment">
        <div class="columns-segment__container" :style="{ gridTemplateColumns: columns }">
            <div class="columns-segment__column" v-for="column in segmentData.columns" :key="column.id">
                <component
                    v-for="segment in column.segments"
                    :key="segment.id"
                    :is="segment.type + '-segment'"
                    :segment-data="segment.data"
                    :id="segment.id"
                ></component>
            </div>
        </div>
    </div>
</template>

<script>
import TextSegment from "~/components/handbook/segments/Text";
import TitleSegment from "~/components/handbook/segments/Title";
import ImageSegment from "~/components/handbook/segments/Image";
import PoiSegment from "~/components/handbook/segments/Poi";
import VideoSegment from "~/components/handbook/segments/Video";
import QuoteSegment from "~/components/handbook/segments/Quote";
import DividerSegment from "~/components/handbook/segments/Divider";

export default {
    components: { TextSegment, TitleSegment, ImageSegment, DividerSegment, PoiSegment, VideoSegment, QuoteSegment },

    props: {
        id: String,
        segmentData: Object,
    },

    computed: {
        columns() {
            // Reformat column width format from % CSS units to fr and combine into a single string.
            return this.segmentData.columns.reduce((acc, column) => {
                acc += " " + column.width.replace("%", "fr");
                return acc;
            }, "");
        },
    },
};
</script>

<style lang="scss"></style>
